var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStepLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.342,
    height: 71.667,
    viewBox: "0 0 65.342 71.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M368.729,322.024c-7.022-11.736-17.6-19.629-27.484-21.065l.054,3.066a14.974,14.974,0,0,0,4.155,10.456,20.149,20.149,0,0,1,4.033,10.626c.039.385.049.771.087,1.149.443,4.441-.435,18.567-.435,18.567l-2.292.229-2.058-20.634-2.4.24,1.112,20.728-.03,0-2.448.244-3.005-20.539-2.4.239,2.058,20.634-2.292.228s-3.652-13.674-4.1-18.115c-.038-.378-.1-.758-.142-1.143A20.134,20.134,0,0,1,333,315.723a14.968,14.968,0,0,0,2.008-11.071l-.657-3.586-.068.011c-11.544,2.269-20.512,15.47-22.288,29.265s3.695,28.1,16.907,35.956a48.334,48.334,0,0,0,20.732,6.329l1.13-16.964,9.2.613L358.894,372.3c5.2-.819,9.773-2.777,12.859-6.078,8.876-9.434,5.609-29.692-3.025-44.2m-6.849,5.474-1.56,23.415a3.072,3.072,0,0,1-3.268,2.86l-6.131-.409,2.245-33.7a3.117,3.117,0,0,1,5.361-1.929,12.3,12.3,0,0,1,3.353,9.758",
    transform: "translate(-311.672 -300.959)",
    fill: "#2c3434"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepLogo);
export default __webpack_public_path__ + "static/media/stepLogo.0aefe96edb7712c6e844da1b5c98aee0.svg";
export { ForwardRef as ReactComponent };